<template>
  <div class="articleWrapper">
    <div>
      Image
      <input type="file" @change="processFile($event)" />
      <img :src="imageUrl" class="preview" />
    </div>
    <md-field>
      <label>title</label>
      <md-input v-model="title"></md-input>
    </md-field>
    <md-field>
      <label>Description</label>
      <md-textarea v-model="desc"></md-textarea>
    </md-field>

    <button @click="method()">Create</button>
    <vue-editor class="vueEditorFixHeight" v-model="content"></vue-editor>
    <md-button @click="onDelete()" v-if="this.adventure && this.adventure.ownId">Delete {{warning}}</md-button>
  </div>
</template>

<script>
// @ is an alias to /src
import { VueEditor } from "vue2-editor";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "me",
  components: {
    VueEditor
  },
  mounted() {
    this.method = this.onCreateAdventure;
    if (this.adventure) {
      this.method = this.onUpdateAdventure;
      this.content = this.adventure.content;
      this.title = this.adventure.title;
      this.imageUrl = this.adventure.image;
      this.desc = this.adventure.desc;
    }
  },
  data() {
    return {
      content: "",
      selected: "",
      title: "",
      selectedCon: "",
      imageUrl: null,
      desc: "",
      warning: undefined,
      url:
        "https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
    };
  },
  props: ["adventure"],
  methods: {
    ...mapActions([
      "addArticle",
      "addAdventure",
      "uploadImage",
      "updateAdventure",
      "deleteAdventure"
    ]),
    async onUpdateAdventure() {
      const data = {
        content: this.content,
        title: this.title,
        image: this.imageUrl,
        desc: this.desc
      };
      await this.updateAdventure({
        adventure: data,
        ownId: this.adventure.ownId
      });
      this.$router.push("/dashboard");
    },
    async onCreateAdventure() {
      await this.addAdventure({
        content: this.content,
        title: this.title,
        image: this.imageUrl,
        desc: this.desc
      });
      this.$router.push("/dashboard");
    },
    async processFile(event) {
      var file = event.target.files[0];
      const { url } = await this.uploadImage(file);
      this.imageUrl = url;
    },
    async onDelete() {
      if (!this.warning) {
        this.warning = "(Click again to confirm deletion)";
        return;
      }
      await this.deleteAdventure(this.adventure.ownId);
      this.$router.push("/dashboard");
    }
  },
  computed: {
    ...mapGetters(["getAllContinentsList", "getAllCountriesList"])
  }
};
</script>

<style >
#mapid2 {
  height: 500px;
}
.addBtn {
  background-color: white;
  color: black;
  height: 50px;
  margin: 10px;
}
.addBtn:hover {
  cursor: pointer;
}

.articleWrapper {
  background-color: white;
  color: black;
  height: 80vh;
}
</style>
